import Vue from "vue";

const cleanups = new WeakMap();

Vue.directive("draggable-dialog", {
  inserted(el, binding) {
    const handleSelector = binding.value && binding.value.handle
      ? binding.value.handle
      : ".dialog-drag-handle";
    const handle = el.querySelector(handleSelector);

    if (!handle) return;

    const dialog = el.closest(".v-dialog") || el;
    let offsetX = 0;
    let offsetY = 0;
    let startX = 0;
    let startY = 0;

    handle.classList.add("dialog-drag-handle--active");

    const stopDragging = () => {
      document.removeEventListener("mousemove", moveDialog);
      document.removeEventListener("mouseup", stopDragging);
      document.body.classList.remove("dialog-is-dragging");
    };

    const moveDialog = event => {
      const requestedX = offsetX + event.clientX - startX;
      const requestedY = offsetY + event.clientY - startY;
      const rect = dialog.getBoundingClientRect();
      const minX = offsetX - rect.left + 12;
      const maxX = offsetX + window.innerWidth - rect.right - 12;
      const minY = offsetY - rect.top + 12;
      const maxY = offsetY + window.innerHeight - rect.bottom - 12;

      offsetX = Math.min(Math.max(requestedX, minX), maxX);
      offsetY = Math.min(Math.max(requestedY, minY), maxY);
      startX = event.clientX;
      startY = event.clientY;
      dialog.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    };

    const startDragging = event => {
      if (event.button !== 0 || event.target.closest("button, a, input, textarea, select")) return;

      startX = event.clientX;
      startY = event.clientY;
      document.body.classList.add("dialog-is-dragging");
      document.addEventListener("mousemove", moveDialog);
      document.addEventListener("mouseup", stopDragging);
      event.preventDefault();
    };

    handle.addEventListener("mousedown", startDragging);
    cleanups.set(el, () => {
      stopDragging();
      handle.removeEventListener("mousedown", startDragging);
    });
  },
  unbind(el) {
    const cleanup = cleanups.get(el);
    if (cleanup) cleanup();
    cleanups.delete(el);
  },
});
